module.exports = __webpack_public_path__ + "static/media/eu.2eba7797.svg";